import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { business, navLinks } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <>
      <div className="gutter bg-navy-900 py-2 text-center text-[13px] font-medium text-white/90" data-id="element-180" data-mp="31d9x0swgel9b">
        <span className="font-semibold text-water-300" data-id="element-181" data-mp="369qkdkvtwvlc">Under New Ownership — Come Meet Us!</span>
        <span className="hidden sm:inline" data-id="element-182" data-mp="3bb69bo14nm90"> · Edenton, NC · Mon–Thu 8–4 · Fri 8–Noon</span>
      </div>
      <header className={`gutter sticky top-0 z-40 bg-white/95 backdrop-blur transition-shadow duration-200 ${scrolled ? 'shadow-[0_1px_0_rgba(7,27,71,0.08),0_8px_24px_-12px_rgba(7,27,71,0.2)]' : ''}`} data-id="element-183" data-mp="3fcjdltoknhdt">
        <div className="flex h-[88px] items-center justify-between gap-6 lg:h-[108px]" data-id="element-184" data-mp="2ro492eeih1ok">
          <a href="#top" className="shrink-0" aria-label="Soundside Marine Services home" data-id="element-185" data-mp="2morawxi6w86o">
            <img src={business.logo} alt="Soundside Marine Services logo" className="h-16 w-auto lg:h-[84px]" data-id="element-186" data-mp="2hpeo2crbj143" />
          </a>
          <nav aria-label="Primary" className="hidden lg:block" data-id="element-187" data-mp="3ac97r7gb9wgi">
            <ul className="flex items-center gap-1 xl:gap-3" data-id="element-188" data-mp="3acrcksh1hj01">
              {navLinks.map(l => <li key={l.href} data-id="element-189" data-mp="35jpukbljd3c8">
                  <a href={l.href} className="rounded-md px-3 py-2 text-[15px] font-semibold text-navy-900 transition-colors duration-150 hover:text-water-600" data-id="element-190" data-mp="30mfvs5c9bfbq">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div className="flex items-center gap-2 xl:gap-3" data-id="element-191" data-mp="1remeslk344h8">
            <a href={business.tel} className="hidden min-h-[48px] items-center gap-2 rounded-md px-3 text-[15px] font-bold text-navy transition-colors duration-150 hover:text-water-600 xl:inline-flex" data-id="element-192" data-mp="1wco59rjub62q">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-193" data-mp="1mljsmyhmzxb2" />
              {business.phone}
            </a>
            <ButtonLink href="#repower-quote" className="hidden md:inline-flex" data-id="element-194" data-mp="18lijywv4rll1">
              Get a Repower Quote
            </ButtonLink>
            <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-12 w-12 items-center justify-center rounded-md text-navy hover:bg-navy-100 lg:hidden" data-id="element-195" data-mp="yow0ocigd2l4">
              {open ? <XIcon className="h-6 w-6" data-id="element-196" data-mp="2xznne6w1tph6" /> : <MenuIcon className="h-6 w-6" data-id="element-197" data-mp="me50go1n0jot" />}
            </button>
          </div>
        </div>
        <AnimatePresence data-id="element-198" data-mp="hg3gm0we0gca">
          {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
          opacity: 0,
          y: -8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="border-t border-navy/10 pb-6 lg:hidden" data-id="element-199" data-mp="hhejlyi0dk2c">
              <ul className="flex flex-col py-2" data-id="element-200" data-mp="1051ffc2n52de">
                {navLinks.map(l => <li key={l.href} data-id="element-201" data-mp="1f3ll2zj0mwah">
                    <a href={l.href} onClick={() => setOpen(false)} className="flex min-h-[52px] items-center border-b border-navy/5 text-lg font-semibold text-navy-900" data-id="element-202" data-mp="1f2ka0v2029sr">
                      {l.label}
                    </a>
                  </li>)}
              </ul>
              <div onClick={() => setOpen(false)} data-id="element-203" data-mp="22xvqyejql3pl">
                <ButtonLink href="#repower-quote" className="mt-4 w-full" data-id="element-204" data-mp="27xrw4h46716q">
                  Get a Repower Quote
                </ButtonLink>
              </div>
            </motion.nav>}
        </AnimatePresence>
      </header>
    </>;
}